
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/add",
      function () {
        return require("private-next-pages/add.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/add"])
      });
    }
  